import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'


Vue.use(Router)

const routes = [
    {
        path: '/',
        component: resolve => require(['@/views/main.vue'], resolve),
    },
    {
        path: '/helptext',
        component: resolve => require(['@/views/helptext.vue'], resolve),
    },
    {
        path: '/helptext/AboutAccount',
        component: resolve => require(['@/views/helptext/AboutAccount.vue'], resolve),
    },
    {
        path: '/helptext/AboutAccount',
        component: resolve => require(['@/views/helptext/AboutAccount.vue'], resolve),
    },
    {
        path: '/helptext/ChatRelated',
        component: resolve => require(['@/views/helptext/ChatRelated.vue'], resolve),
    },
    {
        path: '/helptext/RulesPlatform',
        component: resolve => require(['@/views/helptext/RulesPlatform.vue'], resolve),
    },
    {
        path: '/smallPage/myIncome',
        component: resolve => require(['@/views/smallPage/myIncome.vue'], resolve),
    },
    {
        path: '/charts/chartsRegYyb',
        component: resolve => require(['@/views/charts/chartsRegYyb.vue'], resolve),
    },
    {
        path: '/Home',
        component: Home,
        children: [
            {
                path: 'index',
                name: 'index',
                component: resolve => require(['@/views/index'], resolve),
                meta: {
                    tabname: '主页'
                },
            },
        ]
    }
];


// 创建路由器
const router = new Router({
    routes
});

router.beforeEach((to, from, next) => {
    next();
    store.dispatch('editableTabs/worktabRoute', {
        to: {
            name: to.name ? to.name : '',
            tabname: (to.meta && to.meta.tabname) ? to.meta.tabname : '',
            path: to.path
        },
        from: {
            name: from.name ? from.name : '',
            tabname: (from.meta && from.meta.tabname) ? from.meta.tabname : '',
            path: from.path
        }
    });
});

export default router
